import React from 'react'
import styled from 'styled-components'

import {
  secondary,
  placeholder,
  borderColor,
  inputBackground,
} from 'styles/colors'
import { title } from 'styles/texts'

import withSuggestions from 'components/withSuggestions'

const Input = styled.input`
  ${title};
  background: ${inputBackground};
  border: 1px solid ${borderColor};
  border-radius: 4px;
  padding: 8px 13px;
  width: 100%;
  -webkit-appearance: none;
  font-size: 16px;
  outline: none;
  margin-right: 5px;

  &::placeholder {
    color: ${placeholder};
  }

  &:focus {
    border-color: ${secondary};
  }
`

const InputField = props => (
  <Input type="text" {...props} active={props.value.length} />
)

class InputWithSuggestions extends React.Component {
  InputField = withSuggestions(InputField, this.props.suggestionsType)

  render() {
    const Field = this.InputField
    return <Field {...this.props} />
  }
}

export default InputWithSuggestions



// WEBPACK FOOTER //
// ./src/components/form/InputWithSuggestions.js